import { Form, Input, InputNumber, Row, Select, Space, Switch } from 'antd';
import styles from '../../Dashboard/index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { createUser, getRoles, selectConfigureSlice } from '../redux/slice';
import { debounce } from 'lodash';

export default function CreateUserModal({
  isOpen,
  setIsOpen,
  onAssign,
  data,
  name
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isEdit = typeof isOpen === 'number';
  const { roles, loading } = useSelector(selectConfigureSlice);

  const handleGetAllRoles = (search = '') => {
    const payload = { search };
    dispatch(getRoles(payload));
  };

  //   on modal close
  const handleClose = () => {
    isEdit ? setIsOpen(null) : setIsOpen(false);
  };

  //after modal is closed
  const handleafterClose = () => {
    form.resetFields();
  };

  //init data
  useEffect(() => {
    handleGetAllRoles();
    if (isEdit && data) {
      form.setFieldsValue({
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        mobile: data.mobile,
        role_id: data.role_id,
        is_active: data.isActive,
        staff_augmentation: data.staff_augmentation ?? false,
        staff_augmentation_percentage: data.staff_augmentation
          ? data.staff_augmentation_percentage
          : undefined
      });
    }
  }, [isEdit, isOpen]);

  const debouncedSearch = useCallback(
    debounce((value) => {
      handleGetAllRoles(value);
    }, 300),
    []
  );

  //   on finish
  const onFinish = (values) => {
    const payload = {
      staff_augmentation: values.staff_augmentation ?? false,
      ...values
    };
    if (!payload.staff_augmentation) {
      delete payload.staff_augmentation_percentage;
    }

    if (isEdit) {
      payload.id = isOpen;
      payload.isActive = values.is_active;
    }
    dispatch(createUser(payload)).then((res) => {
      if (res?.payload?.success) {
        handleClose();
        onAssign();
      }
    });
  };

  return (
    <CustomModal
      visible={isOpen}
      footer={null}
      className={`!w-full sm:!w-[40%] md:!w-[35%] lg:!w-[30%] xl:!w-[25%] ${styles.customModal}`}
      closable={false}
      centered
      afterClose={handleafterClose}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onValuesChange={handleFormValuesChange}
        initialValues={{
          staff_augmentation: false
        }}
      >
        <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
          {isEdit ? 'Edit' : 'Add'} {name}
        </h3>

        <div className={'!mt-4 flex flex-col gap-2'}>
          <FormItem
            label="First name"
            name="first_name"
            rules={[{ required: true, message: 'First name is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Enter first name" />
          </FormItem>
          <FormItem
            label="Last name"
            name="last_name"
            rules={[{ required: true, message: 'Last name is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Enter first name" />
          </FormItem>
          <FormItem
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Email is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Enter email" />
          </FormItem>
          <FormItem
            label="Mobile"
            name="mobile"
            // rules={[{ required: true, message: 'Mobile is required' }]}
            className={styles.customLable}
          >
            <Input placeholder="Enter mobile" />
          </FormItem>

          <FormItem
            label="Role"
            name="role_id"
            rules={[{ required: true, message: 'Role is required' }]}
            className={styles.customLable}
          >
            <Select
              showSearch
              optionFilterProp="children"
              defaultValue="Select role"
              style={{ width: '100%' }}
              className={styles.selectField}
              onSearch={debouncedSearch}
            >
              {roles?.length
                ? roles?.map((item, index) => {
                    return (
                      <option value={item?.id} key={index}>
                        {item?.role}
                      </option>
                    );
                  })
                : ''}
            </Select>
          </FormItem>
          <Row style={{ justifyContent: 'space-between', gap: 5 }}>
            <FormItem
              name="staff_augmentation"
              label="Staff Augmentation"
              valuePropName="checked"
              className={styles.customLable}
            >
              <Switch
                size="small"
                onChange={(checked) => {
                  if (!checked) {
                    form.setFieldsValue({
                      staff_augmentation_percentage: undefined
                    });
                  }
                }}
              />
            </FormItem>
            {/* <FormItem
              shouldUpdate={(prev, curr) =>
                prev.staff_augmentation !== curr.staff_augmentation
              }
            >
              {({ getFieldValue }) =>
                getFieldValue('staff_augmentation') && (
                  <FormItem
                    label="Enter percentage"
                    name="staff_augmentation_percentage"
                    className={styles.customLable}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value === undefined || value === null) {
                            return Promise.resolve();
                          }

                          if (value > 100) {
                            return Promise.reject(
                              new Error('Percentage should not exceed 100')
                            );
                          }

                          return Promise.resolve();
                        }
                      }
                    ]}
                  >
                    <InputNumber
                      style={{ width: '100%' }}
                      min={1}
                      step={10}
                      precision={2}
                      placeholder="e.g. 10"
                      controls={false}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          'Backspace',
                          'Delete',
                          'ArrowLeft',
                          'ArrowRight',
                          'Tab'
                        ];

                        if (
                          allowedKeys.includes(e.key) ||
                          /^[0-9.]$/.test(e.key)
                        ) {
                          return;
                        }

                        e.preventDefault();
                      }}
                      onPaste={(e) => {
                        const pasted = e.clipboardData.getData('text');
                        if (!/^\d*\.?\d*$/.test(pasted)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </FormItem>
                )
              }
            </FormItem> */}
            <FormItem
              shouldUpdate={(prev, curr) =>
                prev.staff_augmentation !== curr.staff_augmentation
              }
            >
              {({ getFieldValue }) =>
                getFieldValue('staff_augmentation') && (
                  <FormItem
                    label="Enter percentage"
                    name="staff_augmentation_percentage"
                    className={styles.customLable}
                    rules={[
                      { required: true, message: 'Please select a percentage' }
                    ]}
                  >
                    <Select
                      placeholder="Select percentage"
                      style={{ width: '100%' }}
                      className={styles.selectField}
                      options={[
                        { label: '50%', value: 50 },
                        { label: '100%', value: 100 }
                      ]}
                    />
                  </FormItem>
                )
              }
            </FormItem>
          </Row>

          {isEdit ? (
            <FormItem
              valuePropName="checked"
              name="is_active"
              label="Is active?"
              className={styles.customLable}
            >
              <Switch size="small" />
            </FormItem>
          ) : null}
        </div>
        <FormItem className="text-center">
          <Space style={{ marginTop: '20px' }}>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => handleClose()}
              type="primary"
              ghost
            >
              Cancel
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              type="primary"
              loading={loading}
            >
              {isEdit ? 'Update' : 'Add'} {name}
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
      <style>{`
        .ant-form-item-explain-error{
        font-size:13px;
        }
        `}</style>
    </CustomModal>
  );
}
